import React from 'react';
import _ from 'lodash';
import RichText from '../RichText/RichText'
import Resource from '../Resource/Resource'
import PullQuote from '../PullQuote/PullQuote'
import Grid from '../Grid/Grid'
import {Link as PrismicLink} from 'prismic-reactjs';
import {PrismicConfig} from "../../config";
import "./Slices.css";
import LinkList from "../LinkList/LinkList";

class Slices extends React.Component {
	renderSlices(data) {
		
		if(!data || !data.length) return [];
		
		let slices = [],
		count = 1;
		_.each(data, (slice) => {
			switch(slice.slice_type) {
				case 'button':
				let data = slice.primary,
				to = data.button_link ? PrismicLink.url(data.button_link, PrismicConfig.linkResolver) : '/';
				slices.push(<a href={to ? to : '/'} className="button -secondary" key={count} target={data.button_link.target}>{data.button_text}</a>);
				break;
				
				case 'resource':
				slices.push(<Resource resource={slice.primary}  key={count} />);
				break;
				
				case 'text_area':
					const isList = slice.primary && slice.primary.content && slice.primary.content[0] && slice.primary.content[0].text &&
						slice.primary.content[0].text.indexOf('%list%') > -1;
					const isMainList = slice.primary && slice.primary.content && slice.primary.content[0] && slice.primary.content[0].text &&
						slice.primary.content[0].text.indexOf('%mainlist%') > -1;
					const is2Columns = slice.primary && slice.primary.content && slice.primary.content[0] && slice.primary.content[0].text &&
						slice.primary.content[0].text.indexOf('%2columns%') > -1;
					const is1Columns = slice.primary && slice.primary.content && slice.primary.content[0] && slice.primary.content[0].text &&
						slice.primary.content[0].text.indexOf('%1columns%') > -1;
					const columns = is1Columns ? 1 : (is2Columns ? 2 : 3);
					let content = slice.primary && slice.primary.content;
					const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
					if ((isList || isMainList) && !isSafari) {
						slices.push(
							<LinkList
								key={count}
								slices={this.props.slices}
								type={isMainList ? 'main' : 'regular'}
								columns={columns}
							/>
						)
					} else if (content && !(isList || isMainList || is2Columns || is1Columns)) {

						// slices.push(<a name="#333"></a>);
						slices.push(<RichText key={count} content={content} />);
          }
				break;
				
				case 'pull_quote':
				slices.push(<PullQuote content={slice.primary}   key={count}/>);
				break;
				
				case 'separator':
				slices.push(<hr key={count}/>);
				break;

				case 'grid':
				slices.push(<Grid content={slice.items} key={count}/>);
				break;

				default:
			}
			count++;
		});
		return slices;
	}
	
	render() {
		return <div className="slices">
		{this.renderSlices(this.props.slices)}
		</div>
	}
}

export default Slices




// WEBPACK FOOTER //
// ./src/components/Slices/Slices.js